// MintUI  import
import {Button} from 'mint-ui'

export default (Vue) => {
    Vue.component(Button.name, Button)
}



// WEBPACK FOOTER //
// ./src/core/tempConfig/tempConfig.js